import { useMemo } from "react"
import { useGetOrganizationAiMembersQuery } from "../generated/graphql"
import { useGraphQLClient } from "./useGraphQLClient"
import { useUser } from "./useUser"

const forceViraScribe =
  process.env.REACT_APP_FORCE_VIRA_SCRIBE?.trim().toLowerCase() === "true"

export const useAIServices = () => {
  const { user } = useUser()
  const graphQLClient = useGraphQLClient()

  const { data: orgFeatures } = useGetOrganizationAiMembersQuery(graphQLClient)

  const isAIServicesMember: boolean = useMemo(() => {
    // Local/dev override: Vira Scribe testing needs POST SESSION / SESSION PREP.
    if (forceViraScribe) {
      return true
    }

    const aiOrgMembers = orgFeatures?.organization_features.filter(
      (organization_feature) =>
        user.organizations &&
        organization_feature.org_id === user.organizations[0].id
    )

    if (aiOrgMembers !== undefined && aiOrgMembers.length > 0)
      return aiOrgMembers[0].ai_services_org_members.includes(user?.id)

    return false
  }, [orgFeatures, user.id, user.organizations])

  return { isAIServicesMember }
}
